import { ChangeEvent } from 'react';
import { createAction } from 'typesafe-actions';

import {
  ECoworkingOfferType,
  ERentDurationUnit,
} from 'shared/repositories/coworking/entities/api/V1BookCoworkingRequestSchema';

import { EBookCoworkingFormFields, EBookCoworkingValidateActionTypes } from './constants';

const onChangePhoneCallback = (value: string): string => {
  return value;
};
const onChangeInputCallback = (event: ChangeEvent<HTMLInputElement>): string => event.target.value;
const onChangeCheckboxCallback = (_event: ChangeEvent<HTMLInputElement>, value: boolean): boolean => value;

export const setPhoneFieldValueAction = createAction(EBookCoworkingFormFields.Phone, onChangePhoneCallback)<string>();
export const setWorkplaceCountFieldValueAction = createAction(
  EBookCoworkingFormFields.WorkplaceCount,
  onChangeInputCallback,
)<string>();
export const setRentStartDateFieldValueAction = createAction(EBookCoworkingFormFields.RentStartDate)<Date | null>();
export const setRentDurationUnitFieldValueAction = createAction(
  EBookCoworkingFormFields.RentDurationUnit,
)<ERentDurationUnit>();
export const setCoworkingOfferTypeValueAction = createAction(
  EBookCoworkingFormFields.CoworkingOfferType,
)<ECoworkingOfferType>();
export const setIsBrokerFieldValueAction = createAction(
  EBookCoworkingFormFields.IsBroker,
  onChangeCheckboxCallback,
)<boolean>();
export const setNameFieldValueAction = createAction(EBookCoworkingFormFields.Name, onChangeInputCallback)<string>();
export const setRentDurationFieldValueAction = createAction(
  EBookCoworkingFormFields.RentDuration,
  onChangeInputCallback,
)<string>();

export const validateAllAction = createAction(EBookCoworkingValidateActionTypes.ValidateAll)();
export const validateByFieldAction = createAction(
  EBookCoworkingValidateActionTypes.ValidateByField,
)<EBookCoworkingFormFields>();
